import React from "react";
import http from '../Http';
import { USER_ROLE } from "../config/business";
import { flushSync } from "react-dom";
import { config } from "process";

const setCertInformation = (sdkkd = '', caserial = '') => {
    const data = {
        "pram_1": sdkkd,
        "pram_2": caserial
    };
    return http.post('ApiGatewaySetInformation', data);        
}
const getBusinessInforByOLN = (sdkkd = '', caserial = '') => {
    const data = {
        "custId": sdkkd
    };
    let urlStr = "getCorpDetailByOLN";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
        "anotherUrl": "",
        "sdkkd": sdkkd,
        "caserial": caserial,
        "client_id": localStorage.getItem('sId')
    }
    return http.post('ApiGateway', bodyData);        
}
const getServicePackageInfo = (sdkkd = '', caserial = '') => {
    const data = {
        limitPackCode: "VN_LIMITPKG_EGOLD50"
    };
    let urlStr = "getServicePackageInfo";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
        "anotherUrl": "",
        "sdkkd": sdkkd,
        "caserial": caserial,
        "client_id": localStorage.getItem('sId')
    }
    return http.post('ApiGateway', bodyData);        
}
const getCustomerInformation = (cifNo = '',sdkkd = '', caserial = '') => {
    const data = {
        "cifNo": cifNo
    };
    let urlStr = "getIBInformation";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
        "anotherUrl": "",
        "sdkkd": sdkkd,
        "caserial": caserial,
        "client_id": localStorage.getItem('sId')
    }
    return http.post('ApiGateway', bodyData); 
}
const listUsersByEmailOrUsername = (userName = '',sdkkd = '', caserial = '') => {
    const data = {
        "userName": userName
    }
    let urlStr = "listUsersByEmailOrUsername";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
        "anotherUrl": "",
        "sdkkd": sdkkd,
        "caserial": caserial,
        "client_id": localStorage.getItem('sId')
    }
    return http.post('ApiGateway', bodyData);     
}
const listUsersByUsernames = async (userName = '',sdkkd = '', caserial = '') => {
    const data = {
        "userName": userName
    }
    let urlStr = "listUsersByUsernameV2";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
        "anotherUrl": "",
        "sdkkd": sdkkd,
        "caserial": caserial,
        "client_id": localStorage.getItem('sId')
    }
    return http.post('ApiGateway', bodyData);     
}
const listUsersByUsername = (userName = '',sdkkd = '', caserial = '') => {
    const data = {
        "userName": userName
    }
    let urlStr = "listUsersByUsername";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
        "anotherUrl": "",
        "sdkkd": sdkkd,
        "caserial": caserial,
        "client_id": localStorage.getItem('sId')
    }
    return http.post('ApiGateway', bodyData);          
}

const createOTP = (data) => {
    let urlStr = "reset-password/create-otp";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
        "anotherUrl": "",
        "sdkkd": "",
        "caserial": "",
        "client_id": ""
    }
    return http.post('ApiGateway', bodyData);    
}

const verifyOTP = (data) => {
    let urlStr = "reset-password/verify-otp";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
        "anotherUrl": "",
        "sdkkd": "",
        "caserial": "",
        "client_id": ""
    }
    return http.post('ApiGateway', bodyData);    
}
const createInternetBankingCorpOnline = (cifNo, companyName, sdkkd, listUser, caSerial, 
                                        custAccts, branchCodes,user, maker, approver,
                                        approveAuth, checkerAuth, makerAuth, businessAuth, 
                                        useSMSBanking, smsBiendongsodu = "", smsNhacNo = "", emailList = "",
                                        isModifyUser, attachment, attachmentName, sms, description, address) => {
    maker = "ibank_sys_maker";
    user = "ibank_sys_maker";
    approver = "ibank_system_appr";

    let users = [];
    let chuDN = listUser.find(obj => obj.isChuDN === true);
    listUser.map(user => {
        let newUser = {
            "cifNo": cifNo,
            "userName": user.username,
            "firstName": user.fullname,
            "email": user.email,
            "phone": user.sdt,
            "role": user.roleCode,
            "custUserAccts": custAccts,
            "userFuncs": isModifyUser === true ? "VN_MENUPKG_EBASIC" : "VN_MENUPKG_EGOLD",
            "userFuncNames": isModifyUser === true ? "Gói menu EBASIC" :"Gói menu EGOLD",
            "transactionRestriction":"0",
            "autoUpdate":"0",
            "authenType": user.roleCode === USER_ROLE.APPROVER ? approveAuth 
            : user.roleCode === USER_ROLE.CHECKER ? checkerAuth : user.roleCode === USER_ROLE.MAKER ? makerAuth : ""  // phương thức xác thực
        };
        users.push(newUser);
    });
    let splitCustAccs = custAccts.split(',');
    let accountFee = "";
    if(splitCustAccs.length > 0)
    {
        accountFee = splitCustAccs[0];
    }
    let custAccounts = [];
    splitCustAccs.map(cusA => {
            let cusAccount = {
            "accountNo": cusA
        };
        custAccounts.push(cusAccount);
    });
    let smsAccountFee = sms ? sms.smsAccountFee : "";

    let splitBranchs = branchCodes.split(',');
    let branchCode = "";
    if(splitBranchs.length > 0)
    {
        branchCode = splitBranchs[0];
    }
    let externalData = {
        "custid": cifNo,
        "bankBranch": branchCode,
        "caSerial": caSerial,
        "createDate": Date.now(),
        "creator": maker,
        "customerEmail": chuDN ? chuDN.email : "",        
        // "serviceType": "IB",
        // "servicePackCode": isModifyUser === true ? "VN_SERVICEPKG_EBASIC" : "VN_SERVICEPKG_EGOLD",
        // "status": "1",
        // "accountFee": accountFee,
        // "maker":maker,
        // "approver":approver,
        // "custAccts": custAccounts,
        "ib":{
            "servicePackCode": isModifyUser === true ? "VN_SERVICEPKG_EBASIC" : "VN_SERVICEPKG_EGOLD",
            "servicePackName": isModifyUser === true ? "Gói dịch vụ eBasic" : "Gói dịch vụ eGold",
            "custAccts":custAccts,
            "limitPerTrans":"",
            "limitPerDay":"",
            "accountFee":accountFee,
        },
        "users": users,
        "sms": useSMSBanking === true ? {
            "smsAccountFee": smsAccountFee ? smsAccountFee : accountFee,
            "mobileList": smsBiendongsodu,  // sms acct bien dong so du
            "smsNotify": smsNhacNo, // sms notify nha no
            "smsAcctSerPack": smsBiendongsodu ? "VN_SERVICEFEE_SMSSODU" : "",
            "smsAcctSerPackName": smsBiendongsodu ? "phí dịch vụ sms biến động số dư" : "",
            "smsNotifyAcctFee": smsAccountFee ? smsAccountFee : accountFee,
            "smsNotifySerPack": smsNhacNo ? "VN_SERVICEFEE_SMSNHACNO" : "",
            "smsNotifySerPackName": smsNhacNo ? "Phí dịch vụ nhắc nợ tự động" : "",
        } : {}
    };

    let d = new Date();
    let month = d.getMonth()+1;
    if(month.toString().length === 1)
    {
        month = "0" + month;
    }
    let datestring = d.getFullYear()  + "" + month + "" + d.getDate();

    const reqMsgWSO2 = "{\"SystemCode\": \"ODS_SRV\",\"FunctionCode\": \"CIF_SRV_MAIN_SELL\",\"MultiRow\": true,\"parameters\": [{\"ParamName\": \"P_CIF_NO\",\"ParamInOut\": \"IN\",\"ParamType\": \"VARCHAR2\",\"ParamValue\":\"" + cifNo + "\"},{\"ParamName\": \"P_IDNTY_NBR\",\"ParamInOut\": \"IN\",\"ParamType\": \"VARCHAR2\",\"ParamValue\": \"XXXX\"},{\"ParamName\":\"OUT_CUR\",\"ParamInOut\": \"OUT\",\"ParamType\":\"REF CURSOR\",\"ParamValue\": null}]}" ;
    const dataWSO2 = {
        "apiUrl":"<API_WSO2>",
        "bearerKey":"<TOKEN_WSO2>",
        "reqMsg":reqMsgWSO2
    }

    const reqMsgCreateOpp = "{\"DESCRIPTION\":\""+ description + "\",\"CIF_NO\":\""+ cifNo + "\",\"ODS_ID\":\"<RM_ID_TO_CRM>\",\"PRODUCT\":\"1102001\",\"END_DATE\":\"" + datestring + "\"}" ;
    const dataCreateOpp = {
        "apiUrl":"<API_CREATE_OPP>",
        "tokenKey":"<TOKEN_CREATE_OPP>",
        "reqMsg":reqMsgCreateOpp
    }

    const reqMsgECM = "{\"docClass\": \"Document\",\"system\": \"ONELINK\",\"posCode\": \"110000\",\"customerCode\": \"00000000A1\",\"folderPath\": \"NHS/Ebanking DN\",\"fileName\": \"" + attachmentName + "\",\"fileType\": \"application/pdf\",\"content\": \"" + attachment + "\",\"docInfo\": []}" ;
    const dataECM = {
        "apiUrl":"<API_UPLOAD_FILE_ECM>",
        "tokenKey":"<TOKEN_UPLOAD_FILE_ECM>",
        "reqMsg": reqMsgECM
    }

    const data = {
        "tranType":"BU_EBANK",
        "isCreateByIbankingOnline": "1",
        "isModifiedEmailAccountHolder": isModifyUser === true ? "1" : "",
        "cifNo":cifNo,
        "custName":companyName,
        "taxId":sdkkd,
        "maker":maker,
        "approver":approver,
        "branchCode":branchCode,
        "externalData": JSON.stringify(externalData),
        "action":"ADD",
        "userName":user,
        "status":"APPROVED",
        "userAgent":"OneLink",
        "clientIp":"",
        "rmInformationByCifNoReq": JSON.stringify(dataWSO2),
        "createOpportunityInCRMReq": JSON.stringify(dataCreateOpp),
        "uploadDocumentToECMReq": JSON.stringify(dataECM),
        "ipAdress": address,
        attachment,
        attachmentName
    };
    let urlStr = "createInternetBankingCorpOnline";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
        "anotherUrl": "",
        "sdkkd": sdkkd,
        "caserial": caSerial,
        "client_id": localStorage.getItem('sId')
    }
    return http.post('ApiGateway', bodyData);
}
const createInternetBankingCorpOnlineV2 = async (cifNo, companyName, sdkkd, listUser, caSerial, 
    custAccts, branchCodes,user, maker, approver,
    approveAuth, checkerAuth, makerAuth, businessAuth, 
    useSMSBanking, smsBiendongsodu = "", smsNhacNo = "", emailList = "",
    isModifyUser, attachment, attachmentName, sms, description, address, smsData, feeCollectingAcc) => {
        
        let _countUserName = 0;
        await listUsersByUsernames(listUser.map(u => u.username).join(";"), sdkkd, caSerial).then(response => {
            _countUserName = response.data.content.length;
        }).catch(e => {
        });
        if(_countUserName === 0){
            return createInternetBankingCorpOnlineAssist(cifNo, companyName, sdkkd, listUser, caSerial, 
                custAccts, branchCodes,user, maker, approver,
                approveAuth, checkerAuth, makerAuth, businessAuth, 
                useSMSBanking, smsBiendongsodu, smsNhacNo, emailList,
                isModifyUser, attachment, attachmentName, sms, description, address, smsData, feeCollectingAcc);
        }else {
            throw new Error();
        }
}

const createInternetBankingCorpOnlineAssist = (cifNo, companyName, sdkkd, listUser, caSerial, 
    custAccts, branchCodes,user, maker, approver,
    approveAuth, checkerAuth, makerAuth, businessAuth, 
    useSMSBanking, smsBiendongsodu = "", smsNhacNo = "", emailList = "",
    isModifyUser, attachment, attachmentName, sms, description, address, smsData, feeCollectingAcc) => {
    maker = "ibank_sys_maker";
    user = "ibank_sys_maker";
    approver = "ibank_system_appr";

    let users = [];
    let chuDN = listUser.find(obj => obj.isChuDN === true);
    listUser.map(user => {
    let newUser = {
    "cifNo": cifNo,
    "userName": user.username,
    "firstName": user.fullname,
    "email": user.email,
    "phone": user.sdt,
    "role": user.roleCode,
    "custUserAccts": custAccts,
    "userFuncs": isModifyUser === true ? "VN_MENUPKG_EBASIC" : "VN_MENUPKG_EGOLD",
    "userFuncNames": isModifyUser === true ? "Gói menu EBASIC" :"Gói menu EGOLD",
    "transactionRestriction":"0",
    "autoUpdate":"0",
    "authenType": user.authentype
    // "authenType": user.roleCode === USER_ROLE.APPROVER ? approveAuth 
    // : user.roleCode === USER_ROLE.CHECKER ? checkerAuth : user.roleCode === USER_ROLE.MAKER ? makerAuth : ""  // phương thức xác thực
    };
    users.push(newUser);
    });
    let splitCustAccs = custAccts.split(',');
    let accountFee = "";
    if(splitCustAccs.length > 0)
    {
    accountFee = splitCustAccs[0];
    }
    let custAccounts = [];
    splitCustAccs.map(cusA => {
    let cusAccount = {
    "accountNo": cusA
    };
    custAccounts.push(cusAccount);
    });
    let smsAccountFee = sms ? sms.smsAccountFee : "";

    let splitBranchs = branchCodes.split(',');
    let branchCode = "";
    if(splitBranchs.length > 0)
    {
    branchCode = splitBranchs[0];
    }

    smsData = smsData.map(s => {
        let allAccount = s.accounts && s.accounts.filter(a => a.value === 'ALL');
        if(allAccount && allAccount.length > 0){
            return {debtNoti: s.debtNoti, balanceNoti: s.balanceNoti, sdt: s.sdt, accounts: ['ALL']}
        } else {
            return {debtNoti: s.debtNoti, balanceNoti: s.balanceNoti, sdt: s.sdt, accounts: s.accounts.map(a => a.value)}
        }
    });
    let externalData = {
        "custid": cifNo,
        "bankBranch": branchCode,
        "caSerial": caSerial,
        "createDate": Date.now(),
        "creator": maker,
        "customerEmail": chuDN ? chuDN.email : "",        
        // "serviceType": "IB",
        // "servicePackCode": isModifyUser === true ? "VN_SERVICEPKG_EBASIC" : "VN_SERVICEPKG_EGOLD",
        // "status": "1",
        // "accountFee": accountFee,
        // "maker":maker,
        // "approver":approver,
        // "custAccts": custAccounts,
        "ib":{
        "servicePackCode": isModifyUser === true ? "VN_SERVICEPKG_EBASIC" : "VN_SERVICEPKG_EGOLD",
        "servicePackName": isModifyUser === true ? "Gói dịch vụ eBasic" : "Gói dịch vụ eGold",
        "custAccts":custAccts,
        "limitPerTrans":"",
        "limitPerDay":"",
        "accountFee":accountFee,
        },
        "users": users,
        smsData: useSMSBanking ? smsData : null,
        feeCollectingAcc: feeCollectingAcc.value,
        "sms": useSMSBanking === true ? {
            "smsAccountFee": smsAccountFee ? smsAccountFee : accountFee,
            "mobileList": smsBiendongsodu,  // sms acct bien dong so du
            "smsNotify": smsNhacNo, // sms notify nha no
            "smsAcctSerPack": smsBiendongsodu ? "VN_SERVICEFEE_SMSSODU" : "",
            "smsAcctSerPackName": smsBiendongsodu ? "phí dịch vụ sms biến động số dư" : "",
            "smsNotifyAcctFee": smsAccountFee ? smsAccountFee : accountFee,
            "smsNotifySerPack": smsNhacNo ? "VN_SERVICEFEE_SMSNHACNO" : "",
            "smsNotifySerPackName": smsNhacNo ? "Phí dịch vụ nhắc nợ tự động" : ""
        } : {}
    };

    let d = new Date();
    let month = d.getMonth()+1;
    if(month.toString().length === 1)
    {
    month = "0" + month;
    }
    let datestring = d.getFullYear()  + "" + month + "" + d.getDate();

    const reqMsgWSO2 = "{\"SystemCode\": \"ODS_SRV\",\"FunctionCode\": \"CIF_SRV_MAIN_SELL\",\"MultiRow\": true,\"parameters\": [{\"ParamName\": \"P_CIF_NO\",\"ParamInOut\": \"IN\",\"ParamType\": \"VARCHAR2\",\"ParamValue\":\"" + cifNo + "\"},{\"ParamName\": \"P_IDNTY_NBR\",\"ParamInOut\": \"IN\",\"ParamType\": \"VARCHAR2\",\"ParamValue\": \"XXXX\"},{\"ParamName\":\"OUT_CUR\",\"ParamInOut\": \"OUT\",\"ParamType\":\"REF CURSOR\",\"ParamValue\": null}]}" ;
    const dataWSO2 = {
    "apiUrl":"<API_WSO2>",
    "bearerKey":"<TOKEN_WSO2>",
    "reqMsg":reqMsgWSO2
    }

    const reqMsgCreateOpp = "{\"DESCRIPTION\":\""+ description + "\",\"CIF_NO\":\""+ cifNo + "\",\"ODS_ID\":\"<RM_ID_TO_CRM>\",\"PRODUCT\":\"1102001\",\"END_DATE\":\"" + datestring + "\"}" ;
    const dataCreateOpp = {
    "apiUrl":"<API_CREATE_OPP>",
    "tokenKey":"<TOKEN_CREATE_OPP>",
    "reqMsg":reqMsgCreateOpp
    }

    const reqMsgECM = "{\"docClass\": \"Document\",\"system\": \"ONELINK\",\"posCode\": \"110000\",\"customerCode\": \"00000000A1\",\"folderPath\": \"NHS/Ebanking DN\",\"fileName\": \"" + attachmentName + "\",\"fileType\": \"application/pdf\",\"content\": \"" + attachment + "\",\"docInfo\": []}" ;
    const dataECM = {
    "apiUrl":"<API_UPLOAD_FILE_ECM>",
    "tokenKey":"<TOKEN_UPLOAD_FILE_ECM>",
    "reqMsg": reqMsgECM
    }

    const data = {
    "tranType":"BU_EBANK",
    "isCreateByIbankingOnline": "1",
    "isModifiedEmailAccountHolder": isModifyUser === true ? "1" : "",
    "cifNo":cifNo,
    "custName":companyName,
    "taxId":sdkkd,
    "maker":maker,
    "approver":approver,
    "branchCode":branchCode,
    "externalData": JSON.stringify(externalData),
    "action":"ADD",
    "userName":user,
    "status":"APPROVED",
    "userAgent":"OneLink",
    "clientIp":"",
    "rmInformationByCifNoReq": JSON.stringify(dataWSO2),
    "createOpportunityInCRMReq": JSON.stringify(dataCreateOpp),
    "uploadDocumentToECMReq": JSON.stringify(dataECM),
    "ipAdress": address,
    attachment,
    attachmentName
    };
    let urlStr = "createInternetBankingCorpOnline";
    const bodyData = {
    "body" : JSON.stringify(data),
    "url": urlStr,
    "anotherUrl": "",
    "sdkkd": sdkkd,
    "caserial": caSerial,
    "client_id": localStorage.getItem('sId')
    }
    return http.post('ApiGateway', bodyData);
}
const createFirstApproachLog = () => {
    const data = {
        "custId": "",
        "custName": "",
        "clientId": "L8qq9PZyRg6ieKGEKhZolGC0vJWLw8iEJ88DRdyOg",
        "stepName": "KIEM-TRA-CKS",
        "stepRouter": "DN/DANG-KY-IB_0",
        "description": "Bắt đầu truy cập vào màn hình kiểm tra chữ ký số",
    };
    let urlStr = "createSignupStepLog";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
    }
    return http.post('FirstApproach', bodyData); 
}
const createSignupStepLog = (sdkkd = '', caserial = '', stepName, stepRouter, tenDoanhNghiep) => {
    const data = {
        "custId": sdkkd,
        "custName": tenDoanhNghiep,
        "clientId": localStorage.getItem('sId'),
        "stepName": stepName,
        "stepRouter": stepRouter,
        "description": "Đăng ký thành công internet banking online",
    };
    let urlStr = "createSignupStepLog";
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": urlStr,
        "anotherUrl": "",
        "sdkkd": sdkkd,
        "caserial": caserial,
        "client_id": localStorage.getItem('sId')
    }
    return http.post('ApiGateway', bodyData);        
}

const getCaptchaBankGuarentee = (sId = '') => {
    const urlStr = `getCaptchaBankGuarantee`;
    const bodyData = {
        "body": "",
        "url": urlStr,
        "client_id": sId
    }
    return http.post('ApiGatewayNonLogin', bodyData);
}

const getBankGuarentee = (data, sId = '') => {
    const urlStr = `inquiryBankGuaranteeWithCaptcha`;
    const bodyData = {
        "body": JSON.stringify(data),
        "url": urlStr,
        "client_id": sId
    }
    return http.post('ApiGatewayNonLogin', bodyData);
}
const inquiryBankGuaranteeWithoutCaptcha = (data, sId = '') => {
    const urlStr = `inquiryBankGuaranteeWithoutCaptcha`;
    const bodyData = {
        "body": JSON.stringify(data),
        "url": urlStr,
        "client_id": sId
    }
    return http.post('ApiGatewayNonLogin', bodyData);
}

const validateBankGuarentee = (data,sId='')=> {
    const urlStr = `validateGuaranteeLetter`;
    const bodyData = {
        "body": JSON.stringify(data),
        "url": urlStr,
        "client_id": sId
    }
    return http.post('ApiGatewayNonLogin', bodyData);
}
const prepareGuaranteeLetterApi = (data,sId='')=> {
    const urlStr = `prepareGuaranteeLetter`;
    const bodyData = {
        "body": JSON.stringify(data),
        "url": urlStr,
        "client_id": sId
    }
    return http.post('ApiGatewayNonLogin', bodyData);
}
const getBankGuarenteeLetter = (data,sId='')=> {
    const urlStr = `getGuaranteeLetter`;
    const bodyData = {
        "body": JSON.stringify(data),
        "url": urlStr,
        "client_id": sId
    }
    return http.post('ApiGatewayNonLogin', bodyData);
}
const createBankGuarenteeLetter = (data,sId='')=> {
    const urlStr = `createGuaranteeLetter`;
    const bodyData = {
        "body": JSON.stringify(data),
        "url": urlStr,
        "client_id": sId
    }
    return http.post('ApiGatewayNonLogin', bodyData);
}

const getBankGuarenteeWithoutCaptcha = (data,sId = '')=> {
    const bodyData = {
        "body":JSON.stringify(data),
        "client_id": sId
    }
    return http.post('ApiGatewayNonAuthenNoCaptcha', bodyData); 
}

const getListAccountByCustomer = (data,sId = '')=> {
    const bodyData = {
        "body" : JSON.stringify(data),
        "url": "getListAccountByCustomer",
        "anotherUrl": "",
        "client_id": localStorage.getItem('sId')
    }
    return http.post('ApiGateway', bodyData);
}
export { 
    setCertInformation,
    getBusinessInforByOLN, 
    listUsersByEmailOrUsername, 
    listUsersByUsername,
    getCustomerInformation,
    createOTP,
    verifyOTP,
    createInternetBankingCorpOnline,
    createInternetBankingCorpOnlineV2,
    getListAccountByCustomer,
    createFirstApproachLog,
    createSignupStepLog,
    getCaptchaBankGuarentee,
    getBankGuarentee,
    getBankGuarenteeWithoutCaptcha,
    validateBankGuarentee,
    getBankGuarenteeLetter,
    createBankGuarenteeLetter,
    inquiryBankGuaranteeWithoutCaptcha,
    prepareGuaranteeLetterApi,
    getServicePackageInfo
};